// extracted by mini-css-extract-plugin
var _1 = "MagneticWallItemOverflowMenu-module__active--xCqbX";
var _2 = "MagneticWallItemOverflowMenu-module__animatedBackground--dG9lR";
var _3 = "MagneticWallItemOverflowMenu-module__button--HguGA";
var _4 = "MagneticWallItemOverflowMenu-module__container--F3hCj";
export { _1 as "active", _2 as "animatedBackground", _3 as "button", _4 as "container" }
